import { notification } from 'antd'

export const simpleSuccessNotification = (title: string | null | undefined) =>
  notificationHandler({ title, alternateType: 'success' })

export const simpleCreateNotification = (name: string) =>
  simpleSuccessNotification(`${name} successfully created!`)

export const simpleEditNotification = (name: string) =>
  simpleSuccessNotification(`${name} successfully edited!`)

export const simpleRemoveNotification = (name: string) =>
  simpleSuccessNotification(`${name} successfully removed!`)

export const simpleRestoreNotification = (name: string) =>
  simpleSuccessNotification(`${name} successfully restored!`)

export const simpleRevertNotification = ({
  name,
  status,
}: SimpleRevertNotificationOptions) =>
  simpleSuccessNotification(
    `${name} successfully reverted${status ? ` to ${status}` : ''}!`
  )

type SimpleRevertNotificationOptions = {
  name: string
  status?: string
}

/**
 * Opens a simple notification informing the user a specific field was updated
 *
 * The title of the notification will be `fieldName` successfully updated
 *
 * @param fieldName The name of the field that was updated
 * @returns
 */
export const fieldUpdatedNotification = (fieldName: string) =>
  simpleSuccessNotification(`${fieldName} successfully updated`)

export const simpleWarningNotification = (title: string) =>
  notificationHandler({ title, alternateType: 'warning' })

export const simpleErrorNotification = (title: string, message?: string) => {
  notificationHandler({ title, details: message, alternateType: 'error' })
}

export const simpleInfoNotification = (title: string, message?: string) => {
  notificationHandler({ title, details: message, alternateType: 'info' })
}

export const notificationHandler = ({
  details,
  title,
  alternateType: type,
  duration,
  key,
  onClose,
}: NotificationHandlerOptions): void => {
  if (!title) return
  notification[type ?? 'open']({
    key,
    message: title,
    description: details,
    placement: 'bottomRight',
    duration: duration === 'infinite' ? 0 : (duration as number) ?? 4.5,
    onClose: onClose,
  })
}

type NotificationHandlerOptions = {
  title: React.ReactNode
  key?: string
  details?: React.ReactNode
  alternateType?: 'success' | 'error' | 'info' | 'warning'
  /**
   * duration to keep notification open in seconds. Default is 4.5
   */
  duration?: 'infinite' | number
  onClose?: () => void
}
